import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
export function WhoIsForSection() {
  return <section className="bg-cream py-16 md:py-24 px-4" data-id="element-187">
      <div className="max-w-6xl mx-auto" data-id="element-188">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12" data-id="element-189">
          {/* IS FOR */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white p-8 md:p-10 rounded-2xl shadow-lg border-t-4 border-green-500" data-id="element-190">
            <h3 className="text-2xl md:text-3xl font-bold text-navy-900 mb-8" data-id="element-191">
              Esto <span className="text-green-600" data-id="element-192">SÍ</span> es para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-193">
              <li className="flex items-start" data-id="element-194">
                <div className="bg-green-100 p-1 rounded-full mr-4 shrink-0 mt-1" data-id="element-195">
                  <CheckIcon className="w-5 h-5 text-green-600" data-id="element-196" />
                </div>
                <p className="text-slate-700 text-lg" data-id="element-197">
                  Mujeres latinas en USA que sienten que su sueldo ya no alcanza
                  por la inflación.
                </p>
              </li>
              <li className="flex items-start" data-id="element-198">
                <div className="bg-green-100 p-1 rounded-full mr-4 shrink-0 mt-1" data-id="element-199">
                  <CheckIcon className="w-5 h-5 text-green-600" data-id="element-200" />
                </div>
                <p className="text-slate-700 text-lg" data-id="element-201">
                  Madres que quieren trabajar desde casa para no perderse el
                  crecimiento de sus hijos.
                </p>
              </li>
              <li className="flex items-start" data-id="element-202">
                <div className="bg-green-100 p-1 rounded-full mr-4 shrink-0 mt-1" data-id="element-203">
                  <CheckIcon className="w-5 h-5 text-green-600" data-id="element-204" />
                </div>
                <p className="text-slate-700 text-lg" data-id="element-205">
                  Emprendedoras que no tienen espacio para inventario ni miles
                  de dólares para invertir.
                </p>
              </li>
              <li className="flex items-start" data-id="element-206">
                <div className="bg-green-100 p-1 rounded-full mr-4 shrink-0 mt-1" data-id="element-207">
                  <CheckIcon className="w-5 h-5 text-green-600" data-id="element-208" />
                </div>
                <p className="text-slate-700 text-lg" data-id="element-209">
                  Personas que manejan redes sociales pero no saben cómo
                  convertirlas en una máquina de dinero.
                </p>
              </li>
            </ul>
          </motion.div>

          {/* IS NOT FOR */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-white p-8 md:p-10 rounded-2xl shadow-lg border-t-4 border-red-500" data-id="element-210">
            <h3 className="text-2xl md:text-3xl font-bold text-navy-900 mb-8" data-id="element-211">
              Esto <span className="text-red-600" data-id="element-212">NO</span> es para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-213">
              <li className="flex items-start" data-id="element-214">
                <div className="bg-red-100 p-1 rounded-full mr-4 shrink-0 mt-1" data-id="element-215">
                  <XIcon className="w-5 h-5 text-red-600" data-id="element-216" />
                </div>
                <p className="text-slate-700 text-lg" data-id="element-217">
                  Gente que busca "dinero mágico" sin dedicarle al menos 1 hora
                  al día a su negocio.
                </p>
              </li>
              <li className="flex items-start" data-id="element-218">
                <div className="bg-red-100 p-1 rounded-full mr-4 shrink-0 mt-1" data-id="element-219">
                  <XIcon className="w-5 h-5 text-red-600" data-id="element-220" />
                </div>
                <p className="text-slate-700 text-lg" data-id="element-221">
                  Personas que no están dispuestas a aprender a usar
                  herramientas básicas como Shopify.
                </p>
              </li>
              <li className="flex items-start" data-id="element-222">
                <div className="bg-red-100 p-1 rounded-full mr-4 shrink-0 mt-1" data-id="element-223">
                  <XIcon className="w-5 h-5 text-red-600" data-id="element-224" />
                </div>
                <p className="text-slate-700 text-lg" data-id="element-225">
                  Aquellos que prefieren quejarse de la economía en lugar de
                  tomar acción para cambiarla.
                </p>
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}